<template>
	<div>
		<navigation msg="商品管理/基本信息" />
		<keep-alive>
		    <router-view v-if="$route.meta.keepAlive"></router-view>
		</keep-alive>
		<router-view v-if="!$route.meta.keepAlive"></router-view>
		<!-- <keep-alive>
			
		</keep-alive> -->
	</div>
</template>

<script>
	import navigation from '@/components/comm/navigation.vue'
	export default {
		data() {
			return {

			}
		},
		components: {
			navigation
		},
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/oper/commodity/comm/home.vue